<template>
    <div class="publication-author">
        <div class="publication-author__owner">
            <AAvatar :src="result.picture.src" :alt="result.picture.alt" :title="result.picture.title" width="70" class="publication-author__image"/>
            <div>
                <h6 class="publication-author__name">
                    {{ result.name }}
                </h6>
                <span class="publication-author__position">{{getFirstPosition}}</span>
            </div>
        </div>
        <div class="publication-author-social" v-if="result.socials">

            <a v-for="(social, key) in result.socials" :href="social" class="publication-author-social__item">
                <img :src="`/local/templates/main/img/icons/socials/${key}.svg`" alt="">
            </a>
        </div>
    </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import {computed} from "vue";
import {AAvatar} from "../../ui";

export default {
    name: 'PublicationAuthor',
    props: ['result'],
    components: {
        AAvatar
    },
    setup(props) {
        const getFirstPosition = computed(() => {
            if(Array.isArray(props.result.directions) && !isEmpty(props.result.directions[0])) {
                return props.result.directions[0].name
            }

            return ''
        })

        return {
            getFirstPosition
        }
    }
}
</script>

<style lang="scss" scoped>
.publication-author {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 28px 33px;
    border: 1px solid #E9EBED;
    border-radius: 9px;
    margin: 53px 0;
    @include mobile {
        flex-direction: column;
        align-items: flex-start;
        padding: 28px 18px;
        margin: 60px 0;
    }

    &__owner {
        display: grid;
        grid-template-columns: 68px 1fr;
        grid-column-gap: 21px;
        align-items: center;
        @include mobile {
            grid-template-columns: 1fr;
            grid-row-gap: 18px;
            margin-bottom: 11px;
        }
    }

    &__image {
        display: block;
        max-width: 68px;
        border-radius: 50%;
    }

    &__name {
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        color: #252425;
        margin-bottom: 3px;
    }

    &__position {
        font-size: 14px;
        line-height: 20px;
        color: #6367A7;
    }
}

.publication-author-social {
    display: flex;

    &__item {
        cursor: pointer;
        display: inline-flex;
        background: #2F3941;
        border-radius: 6px;
        margin-right: 7px;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;

        img, svg {
            width: 12px;
            height: 12px;
        }

        &:not(:last-child) {
            margin-right: 18px;
            @include mobile {
                margin-right: 8px;
            }
        }
    }

    &__icon {
        width: 30px;
        height: 30px;
    }
}
</style>